import React, { Fragment } from "react";
import { MuiIcons } from "utils";
import clsx from "classnames";
import PropTypes from "prop-types";

export const buttonStyle = {
    outline: "none",
    borderRadius: "0px",
    height: "40px"
};

const BCustomButton = ({
    onClick,
    title,
    isExport,
    icon,
    style,
    color,
    spinner,
    className,
    ...rest
}) => {
    
    const baseClass = clsx(
        "btn with-linear-gradient shadow-none",
        color,
        "b-custom-button",
        className
    );

    return (
        <Fragment>
            <div>
                <button
                    className={baseClass}
                    style={{...style }}
                    onClick={onClick}
                    {...rest}
                >
                    {spinner ? (
                        <>
                            <span
                                className="spinner-border text-white spinner-border-sm ml-2"
                                role="status"
                            />
                            &nbsp;Loading...
                        </>
                    ) : (
                        <div className="d-flex">
                            <span className={"mr-1"}>{MuiIcons[isExport ? "get_app" : icon]}</span>
                            {title}
                        </div>
                    )}
                </button>
            </div>
        </Fragment>
    );
};

BCustomButton.defaultProps = {
    title: "Export",
    onClick: null,
    isExport: false,
    color: "btn-primary",
    spinner: false,
    className: "",
    icon: "add",
    style: {}
};

BCustomButton.propTypes = {
    title: PropTypes.string,
    color: PropTypes.string,
    className: PropTypes.string,
    isExport: PropTypes.bool,
    spinner: PropTypes.bool,
    style: PropTypes.object,
    icon: PropTypes.oneOf(Object.keys(MuiIcons))
};

export default BCustomButton;
